import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15478755"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item" }
const _hoisted_2 = { style: {"width":"5rem"} }
const _hoisted_3 = { class: "item-info" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "desc one-hide" }
const _hoisted_6 = { class: "desc one-hide" }
const _hoisted_7 = {
  key: 0,
  class: "desc one-hide"
}
const _hoisted_8 = {
  key: 1,
  class: "desc one-hide"
}
const _hoisted_9 = {
  key: 2,
  class: "desc one-hide"
}
const _hoisted_10 = { class: "price" }
const _hoisted_11 = { class: "cls-con" }
const _hoisted_12 = { class: "price" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  style: {"font-size":"0.6rem","color":"#aaaaaa"}
}
const _hoisted_15 = {
  key: 0,
  class: "cls-con",
  style: {"font-size":"0.9rem"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#686868"} }, "美容师", -1))
const _hoisted_17 = {
  key: 1,
  class: "cls-con",
  style: {"font-size":"0.9rem"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#686868"} }, "服务时间", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_image, {
          radius: "5",
          width: "5rem",
          height: "6.5rem",
          src: _ctx.item.thumb,
          "lazy-load": ""
        }, null, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.item.serveName), 1),
          _createElementVNode("div", _hoisted_5, "服务商品:" + _toDisplayString(_ctx.item.goodsDesc), 1),
          _createElementVNode("div", _hoisted_6, "服务时长:" + _toDisplayString(_ctx.item.serveTime) + "分钟", 1),
          (_ctx.item.limitTxt)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 限购次数:" + _toDisplayString(_ctx.item.limitTxt), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, "限购次数:" + _toDisplayString(_ctx.item.limitNum) + "次", 1)),
          (_ctx.shareholderState == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createTextVNode(" 超级会员价格:"),
                _createElementVNode("span", _hoisted_10, "￥" + _toDisplayString(_ctx.item.shareholderPrice), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, "￥" + _toDisplayString(_ctx.item.normalPrice), 1),
          (_ctx.item.serveNum)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, "x" + _toDisplayString(_ctx.item.serveNum), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, " 已约" + _toDisplayString(_ctx.item.registerNum) + "次 ", 1))
        ])
      ])
    ]),
    (_ctx.item.staffName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", null, _toDisplayString(_ctx.item.staffName), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.item.staffServeTime)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", null, _toDisplayString(_ctx.item.staffServeTime), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}